import React, { useReducer, createContext } from "react";

import introducerReducer from "../reducers/introducer-reducer";

export const IntroducerContext = createContext();
const IntroducerProvider = IntroducerContext.Provider;

export function IntroducerWrapper({ children }) {
  const defaultIntroducer = React.useMemo(
    () => ({ introducedByCode: null }),
    []
  );

  const storedIntroducer =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("introducer"))
      : null;

  const [introducer, dispatchIntroducer] = useReducer(
    introducerReducer,
    storedIntroducer || defaultIntroducer
  );

  // Cache introducer in localStorage when it changes
  React.useEffect(() => {
    if (introducer) {
      localStorage.setItem("introducer", JSON.stringify(introducer));
    }
  }, [introducer]);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = React.useMemo(
    () => ({ introducer, dispatchIntroducer, defaultIntroducer }),
    [introducer, defaultIntroducer]
  );

  return (
    <IntroducerProvider value={contextValue}>{children}</IntroducerProvider>
  );
}
